import useTranslate from "../../hooks/useTranslate";
import { IDateRange } from "./DateRange.props";
import { DateRangeRoot, DateTextField, ClearButton } from "./DateRange.styles";
import { ChangeEvent, FC } from "react";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const DateRange: FC<IDateRange> = ({ inputDates, setInputDates, ...props }) => {
	const translate = useTranslate();

	const handleChangeStartDate = (e: ChangeEvent<HTMLInputElement>) => {
		const newStart = e.target.value;
		const currentEnd = inputDates.end;

		if (newStart > currentEnd) {
			setInputDates({ start: newStart, end: newStart });
		} else {
			setInputDates({ start: newStart, end: currentEnd });
		}
	};

	const handleChangeEndDate = (e: ChangeEvent<HTMLInputElement>) => {
		const newEnd = e.target.value;
		const currentStart = inputDates.start;

		if (newEnd < currentStart) {
			setInputDates({ start: currentStart, end: currentStart });
		} else {
			setInputDates({ start: currentStart, end: newEnd });
		}
	};

	const resetStartDate = () => {
		setInputDates((prev) => ({ ...prev, start: "" }));
	};

	const resetEndDate = () => {
		setInputDates((prev) => ({ ...prev, end: "" }));
	};

	return (
		<DateRangeRoot maxWidth={false} {...props}>
			<DateTextField
				label={translate("input_start")}
				variant="outlined"
				type="date"
				value={inputDates.start}
				InputLabelProps={{
					shrink: true,
				}}
				inputProps={{
					max: inputDates.end,
				}}
				onChange={handleChangeStartDate}
				InputProps={{
					endAdornment: inputDates.start && (
						<ClearButton onClick={resetStartDate} title={translate("button.reset")}>
							<FontAwesomeIcon icon={faXmark} />
						</ClearButton>
					),
				}}
			/>

			<DateTextField
				label={translate("input_end")}
				variant="outlined"
				type="date"
				value={inputDates.end}
				InputLabelProps={{
					shrink: true,
				}}
				inputProps={{
					min: inputDates.start,
				}}
				onChange={handleChangeEndDate}
				InputProps={{
					endAdornment: inputDates.end && (
						<ClearButton onClick={resetEndDate} title={translate("button.reset")}>
							<FontAwesomeIcon icon={faXmark} />
						</ClearButton>
					),
				}}
			/>
		</DateRangeRoot>
	);
};

export default DateRange;
